import {http} from "../../Services/Http/HttpClient";
import {ApiListResponse} from "./ApiListResponse";

export interface EnrollmentsListResponse {
    id: string
    name: string,
    price: string,
    createdAt: string,
    updatedAt: string,
    enabled: boolean
}

export interface EnrollmentResponse {
    id: string;
    name: string;
    price: number;
    formattedPrice: string;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
    activitySessions: []
}

export const getEnrollments = async(filters: {[key:string]:string|number} = {}) : Promise<ApiListResponse> => {
    const params = new URLSearchParams();

    for (const key in filters) {
        if (filters.hasOwnProperty(key)) {
            params.append(key, filters[key].toString());
        }
    }

    const paramsString = params.toString().length ? '?' + params.toString() : ''

    return await http.get('/enrollments' + paramsString)
}

export const getEnrollmentDetail = async (id: string) : Promise<EnrollmentResponse> => {
    return await http.get('/enrollments/' + id)
}

export const deleteEnrollments = async (ids: string[]): Promise<any> => {
    return http.delete('/enrollments', {
        data: {
            ids: ids
        }
    })
}
